<template>
  <div class="plan">
    <div class="tab-list">
      <div class="mid">
        <span
          @click="changeType(i.code)"
          :class="activeCode === i.code ? 'active' : ''"
          v-for="i in typeList"
          :key="i.code"
          >{{ i.name }}</span
        >
      </div>
    </div>
    <div class="search-year">
      <span>学年：</span>
      <schoolYearSelector
        v-model="schoolYear"
        :isDefaultValue="true"
        :clearable="false"
      />
    </div>
    <div class="content" v-if="showPage" v-loading="!showPage">
      <!-- 专业规划 -->
      <div class="gh" v-show="activeCode == 'gh'">
        <el-form
          class="setp-form"
          ref="step1form"
          :rules="rules1"
          :model="form1"
          label-width="150px"
          size="small"
        >
          <el-form-item label="专业目标" prop="proTarget">
            <disSelector
              controlType="radio"
              dicType="proTarget"
              v-model="form1.proTarget"
            ></disSelector>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="公开课(活动)申请" prop="isOpenClass">
                <el-radio-group v-model="form1.isOpenClass">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="交流发言申请" prop="isSpeak">
                <el-radio-group v-model="form1.isSpeak">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="带教申请" prop="isTeaching">
                <el-radio-group v-model="form1.isTeaching">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="示范辐射" prop="radiation">
                <el-button type="text" @click="showPop">添加</el-button>
                <ul class="fs-ul">
                  <li v-for="(i, index) in form1.radiation" :key="index">
                    <span>{{ i.radiationType.dicName }}</span> -------------
                    <span>{{ i.num }}次</span>
                    <el-button
                      type="text"
                      class="el-icon-close delrad"
                      @click="delRadIation(i.id)"
                    ></el-button>
                  </li>
                </ul>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="学术文章" prop="articles">
                <el-button type="text" @click="showPop2">添加</el-button>
                <ul class="fs-ul">
                  <li v-for="(i, index) in form1.articles" :key="index">
                    <span>{{ i.articlesType.dicName }}</span> -------------
                    <span>{{ i.num }}次</span>
                    <el-button
                      type="text"
                      class="el-icon-close delrad"
                      @click="delArticles(i.id)"
                    ></el-button>
                  </li>
                </ul>
              </el-form-item>
            </el-col>
          </el-row>
          <h1 class="myfx">自我分析</h1>
          <el-form-item label="优势" prop="advantage">
            <el-input
              v-model="form1.advantage"
              maxlength="1000"
              show-word-limit
              style="width: 600px"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8 }"
              placeholder="请输入本学年的自我优势"
            ></el-input>
          </el-form-item>
          <el-form-item label="不足" prop="inferiority">
            <el-input
              v-model="form1.inferiority"
              maxlength="1000"
              show-word-limit
              style="width: 600px"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8 }"
              placeholder="请输入本学年的自我不足"
            ></el-input>
          </el-form-item>
          <el-form-item label="发展目标" prop="devTarget">
            <el-input
              v-model="form1.devTarget"
              maxlength="1000"
              show-word-limit
              style="width: 600px"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8 }"
              placeholder="请输入本学年的发展目标"
            ></el-input>
          </el-form-item>
          <el-form-item label="实施计划" prop="improve">
            <el-input
              v-model="form1.improve"
              maxlength="1000"
              show-word-limit
              style="width: 600px"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8 }"
              placeholder="请输入本学年的实施计划"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件" prop="attachUrl">
            <uploader
              style="display: inline-block"
              list-type="text"
              :limit="1"
              accept="*"
              :maxSize="30 * 1024 * 1024"
              :file-list.sync="form1.attachUrl"
            />
          </el-form-item>
          <div class="sub-div">
            <el-button
              class="sub-form"
              size="small"
              @click="submitForm1"
              type="primary"
              >保 存</el-button
            >
          </div>
        </el-form>
      </div>
      <!-- 规划达成小结 -->
      <div class="xj" v-show="activeCode == 'xj'">
        <el-form
          class="setp-form"
          ref="step2form"
          :rules="rules2"
          :model="form2"
          label-width="150px"
          size="small"
        >
          <el-form-item label="规划达成小结" prop="summary">
            <el-input
              v-model="form2.summary"
              maxlength="1000"
              show-word-limit
              style="width: 600px"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8 }"
              placeholder="请输入规划达成小结"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件" prop="attachUrl">
            <uploader
              style="display: inline-block"
              list-type="text"
              :limit="1"
              accept="*"
              :maxSize="30 * 1024 * 1024"
              :file-list.sync="form2.attachUrl"
            />
          </el-form-item>
          <div class="sub-div">
            <el-button
              class="sub-form"
              size="small"
              @click="submitForm2"
              type="primary"
              >保 存</el-button
            >
          </div>
        </el-form>
      </div>
      <!-- 全员导师 -->
      <div class="qyds" v-show="activeCode == 'qyds'">
        <el-form
          class="setp-form"
          ref="step3form"
          :rules="rules3"
          :model="form3"
          label-width="150px"
          size="small"
        >
          <el-form-item label="全员导师" prop="isMentor">
            <el-radio-group v-model="form3.isMentor" @change="onIsMentorChange">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="学生名单"
            v-show="form3.isMentor == 1"
            prop="studentList"
          >
            <el-button type="text" @click="onShowDialog">添加</el-button>
            <span style="margin-left: 10px"
              >共{{ form3.studentList.length }}人</span
            >
            <div class="space"></div>
            <el-tag
              size="small"
              color="#f1fddc"
              v-for="tag in form3.studentList"
              :key="tag.id"
              :disable-transitions="false"
              closable
              @close="handleDel(tag)"
              style="margin-left: 12px; padding: 0 8px; color: #81b337"
              >{{ tag.gradeName }}{{ tag.className }}&nbsp;&nbsp;{{
                tag.studentName
              }}</el-tag
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- academicEssay -->
    <el-dialog title="示范辐射" :visible.sync="isShowPop" width="500px" center>
      <div class="transfer-box">
        <span>类型：</span>
        <disSelector
          dicType="radiationType"
          v-model="radiation.radiationType"
        ></disSelector>
        <br />
        <br />
        <span>次数：</span>
        <el-input
          type="number"
          min="1"
          style="width: 225px"
          clearable
          placeholder="请输入"
          v-model="radiation.num"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addOk">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="学术文章" :visible.sync="isShowPop2" width="500px" center>
      <div class="transfer-box">
        <span>类型：</span>
        <disSelector
          dicType="academicEssay"
          v-model="articles.articlesType"
        ></disSelector>
        <br />
        <br />
        <span>次数：</span>
        <el-input
          type="number"
          min="1"
          style="width: 225px"
          clearable
          placeholder="请输入"
          v-model="articles.num"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel2">取 消</el-button>
        <el-button type="primary" @click="addOk2">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 成员导师 -->
    <el-dialog
      title="添加学生"
      :visible.sync="isShowDialog"
      center
      destroy-on-close
      width="80%"
      :before-close="handleClose"
    >
      <el-form class="full-width" :model="filterFrom">
        <div
          class="filter-bar mb-sm"
          type="flex"
          style="flex-direction: column"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item class="mb-none">
                <el-input
                  size="small"
                  v-model="filterFrom.keyword"
                  clearable
                  placeholder="搜索"
                  @input="refresh"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="filter-row mb-2px">
                <!-- <grade-selector
                  v-model="filterFrom.grade"
                  @change="gradeChange"
                ></grade-selector> -->
                <el-select
                  v-model="filterFrom.grade"
                  placeholder="请选择年级"
                  value-key="grade"
                  @change="gradeChange"
                >
                  <el-option
                    v-for="item in gradeOptions"
                    :key="item.gradeName"
                    :label="item.gradeName"
                    :value="item.grade"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="filter-row mb-2px">
                <el-select
                  v-model="filterFrom.classCode"
                  placeholder="请选择班级"
                  value-key="classCode"
                  clearable
                  @change="onChangeClass"
                >
                  <el-option
                    v-for="item in classOptions"
                    :key="item.classCode"
                    :label="item.className"
                    :value="item.classCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="space student-list">
            <ul class="infinite-list" style="overflow: auto">
              <el-checkbox-group
                v-model="studentCheckedList"
                size="small"
                text-color="#81b337"
                fill="#f1fddc"
              >
                <el-checkbox-button
                  v-for="student in allStudentList"
                  :label="student.studentId"
                  :disabled="student.status == 1"
                  :key="student.studentId"
                  >{{ student.gradeName }}&nbsp;{{
                    student.className
                  }}&nbsp;&nbsp;{{ student.studentName }}</el-checkbox-button
                >
              </el-checkbox-group>
            </ul>
          </div>
          <div class="student-list">
            <h4>
              已选择学生&nbsp;&nbsp;&nbsp;&nbsp;
              {{ checkList.length }}人
            </h4>
            <ul class="infinite-list checked-list" style="overflow: auto">
              <li v-for="(student, i) in checkList" :key="student.studentId">
                {{ student.gradeName }}&nbsp;{{
                  student.className
                }}&nbsp;&nbsp;{{ student.studentName }}
              </li>
            </ul>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOk3">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import disSelector from '@/components/school/dicSelector.vue'
import gradeSelector from '@/components/school/gradeSelector.vue'
import schoolYearSelector from '@/components/school/schoolYearSelector.vue'
import uploader from '@/components/school/uploader.vue'
import { getData, postData, postJson } from '@/http/fetch.js'
import { power } from '@/utils/index.js'
import { mapState } from 'vuex'
export default {
  components: {
    schoolYearSelector,
    disSelector,
    gradeSelector,
    uploader
  },
  computed: {
    ...mapState(['userInfo', 'resOptions']),
    checkList() {
      let that = this
      return this.allStudentListD.filter((item) =>
        that.studentCheckedList.includes(item.studentId)
      )
    }
  },
  data() {
    var minLength = (rule, value, callback) => {
      if (!value || value.length < 30) {
        return callback(new Error('请输入内容至少30个字'))
      } else {
        callback()
      }
    }
    return {
      schoolYear: '',
      showPage: true,
      btnLoading: false,
      filterFrom: {
        keyWords: '',
        classCode: '',
        grade: '',
        schoolCode: '',
        schoolYear: ''
      },
      userLogo: require('@/assets/image/other/man_teacher.png'),
      typeList: [
        { code: 'gh', name: '专业规划' },
        { code: 'xj', name: '规划达成小结' },
        { code: 'qyds', name: '全员导师' }
      ],
      activeCode: 'gh',
      form1: {
        proTarget: '',
        isOpenClass: 0,
        isSpeak: 0,
        isTeaching: 0,
        radiation: [], //辐射
        articles: [], //文章
        advantage: '',
        inferiority: '',
        improve: '',
        devTarget: '',
        improve: '',
        operatorId: '',
        schoolCode: '',
        attachUrl: []
      },
      form2: {
        operatorId: '',
        schoolCode: '',
        infoCode: '',
        summary: '',
        attachUrl: []
      },
      form3: {
        isMentor: '',
        studentList: []
      },
      rules3: {
        isMentor: [
          {
            required: true,
            message: '请选择是否是全员导师',
            trigger: 'blur'
          }
        ],
        studentList: [
          {
            required: true,
            message: '请添加学生',
            trigger: 'change'
          }
        ]
      },
      rules2: {
        summary: [{ validator: minLength, trigger: 'blur' }]
      },
      rules1: {
        proTarget: [
          { required: true, message: '请选择专业目标', trigger: 'blur' }
        ],
        isOpenClass: [
          {
            required: true,
            message: '请选择是否公开课(活动)申请',
            trigger: 'blur'
          }
        ],
        isSpeak: [
          {
            required: true,
            message: '请选择是否交流发言申请',
            trigger: 'blur'
          }
        ],
        isTeaching: [
          {
            required: true,
            message: '请选择是否带教申请',
            trigger: 'blur'
          }
        ],
        // radiation: [
        //   {
        //     required: true,
        //     message: "请添加示范辐射",
        //     trigger: "blur",
        //   },
        // ],
        // articles: [
        //   {
        //     required: true,
        //     message: "请添加学术文章",
        //     trigger: "blur",
        //   },
        // ],
        advantage: [
          {
            validator: minLength,
            // message: "请输入本学年的自我优势",
            trigger: 'blur'
          }
        ],
        inferiority: [
          {
            validator: minLength,
            // message: "请输入本学年的自我不足",
            trigger: 'blur'
          }
        ],
        devTarget: [
          {
            validator: minLength,
            // message: "请输入本学年的发展目标",
            trigger: 'blur'
          }
        ],
        improve: [
          {
            validator: minLength,
            // message: "请输入本学年的实施计划",
            trigger: 'blur'
          }
        ]
      },
      radiation: {
        radiationType: '',
        num: '',
        id: 1
      },
      articles: {
        articlesType: '',
        num: '',
        id: 1
      },

      isShowPop: false,
      isShowPop2: false,
      isShowDialog: false,
      classOptions: [],
      gradeOptions: [],
      allStudentList: [],
      allStudentListD: [],
      studentCheckedList: []
    }
  },
  created() {
    this.init()
    this.handelPower()
  },
  methods: {
    async handleDel(tag) {
      await postJson('/planning/deleteMentorStudentInfo', {
        id: tag.id,
        operatorId: this.userInfo.userId
      })
      this.getMentor()

      // this.form3.studentList = this.form3.studentList.filter(
      //   (item) => item.studentId != tag.studentId
      // );
    },
    init() {
      // this.getPlan();
      //this.getSum();
    },
    getSum(schoolYear) {
      this.showPage = false
      postData('/summary/getProSummary', {
        schoolYear: schoolYear || this.schoolYear,
        userId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode
      })
        .then((res) => {
          if (res.id != 0) {
            //编辑
            this.form2 = { ...res }
            this.form2.attachUrl = JSON.parse(
              res.attachUrl ? res.attachUrl : '[]'
            )
          } else if (res.id == 0) {
            this.form2 = {
              operatorId: '',
              schoolCode: '',
              infoCode: '',
              summary: ''
            }
          }
          this.showPage = true
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    getPlan(schoolYear) {
      this.showPage = false
      postData('/planning/getProPlanning', {
        schoolYear: schoolYear || this.schoolYear,
        userId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode
      })
        .then((res) => {
          if (res.id != 0) {
            //编辑
            this.form1 = { ...res }
            this.form1.radiation = JSON.parse(
              res.radiation ? res.radiation : '[]'
            )
            this.form1.attachUrl = JSON.parse(
              res.attachUrl ? res.attachUrl : '[]'
            )
            this.form1.articles = JSON.parse(res.articles ? res.articles : '[]')
          } else if (res.id == 0) {
            this.form1 = {
              proTarget: '',
              isOpenClass: 0,
              isSpeak: 0,
              isTeaching: 0,
              radiation: [], //辐射
              articles: [], //文章
              advantage: '',
              inferiority: '',
              improve: '',
              devTarget: '',
              improve: '',
              operatorId: '',
              schoolCode: ''
            }
          }
          this.showPage = true
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    getMentor(schoolYear) {
      postData('/planning/getTeacherMentorInfo', {
        schoolYear: schoolYear || this.schoolYear,
        teacherId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode
      })
        .then((res) => {
          this.form3.isMentor = res.isMentor
          if (res.isMentor == 0) {
            this.form3.studentList = []
          }
          if (res.studentList) {
            this.form3.studentList = res.studentList
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    async getStudentListByCodes() {
      let res = await postJson(
        '/planning/getStudentListByCodes',
        this.filterFrom
      )
      this.allStudentList = res
      if (res.length > 0) {
        res.forEach((item) => {
          if (
            this.allStudentListD.findIndex(
              (student) => student.studentId == item.studentId
            ) == -1
          ) {
            this.allStudentListD.push(item)
          }
        })
      }
    },
    onIsMentorChange(val) {
      if (val == 0) {
        this.$confirm('此操作将删除您添加的学生列表, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.updateIsMentor()
            this.$message({
              type: 'success',
              message: '变更成功!'
            })
          })
          .catch(() => {
            this.form3.isMentor = 1
            this.$message({
              type: 'info',
              message: '已取消变更'
            })
          })
      } else {
        this.updateIsMentor()
      }
    },
    // 更新教师全员导师状态
    async updateIsMentor() {
      await postData('/planning/updateIsMentor', {
        schoolYear: this.schoolYear,
        teacherId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        isMentor: this.form3.isMentor
      })
      this.$store.dispatch('getUserInfo')
      this.getMentor()
    },

    changeType(code) {
      this.activeCode = code
    },
    async submitForm1() {
      try {
        await this.$refs.step1form.validate()
        this.btnLoading = true
        this.form1.operatorId = this.userInfo.userId
        this.form1.schoolYear = this.schoolYear
        this.form1.schoolCode = this.userInfo.schoolCode
        this.form1.attachUrl = JSON.stringify(this.form1.attachUrl)
        this.form1.radiation = JSON.stringify(this.form1.radiation)
        this.form1.articles = JSON.stringify(this.form1.articles)
        await postJson('/planning/saveOrUpdatePlanning', this.form1)
        this.btnLoading = false
        this.getPlan()
        this.$message.success('保存成功')
      } catch (err) {
        this.btnLoading = false
        console.log('err', err)
      }
    },
    async submitForm2() {
      await this.$refs.step2form.validate()
      try {
        this.btnLoading = true
        this.form2.operatorId = this.userInfo.userId
        this.form2.schoolCode = this.userInfo.schoolCode
        this.form2.attachUrl = JSON.stringify(this.form2.attachUrl)
        this.form2.schoolYear = this.schoolYear
        await postJson('/summary/saveOrUpdateSummary', this.form2)
        this.btnLoading = false
        this.getSum()
        this.$message.success('保存成功')
      } catch (err) {
        this.btnLoading = false
        console.log('err', err)
      }
    },

    async onShowDialog() {
      await postData('/school/getGradeList', {
        schoolCode: this.userInfo.schoolCode
      })
        .then((res) => {
          let list = []
          if (res.length) {
            list = res
            this.gradeOptions = res
            this.filterFrom.grade = res[0].grade
          } else {
            this.gradeOptions = []
          }
        })
        .catch((e) => {
          reject(e)
        })
        .finally(() => {})
      this.gradeChange(this.filterFrom.grade)
      this.isShowDialog = true
      this.filterFrom.classCode = ''
      this.filterFrom.keyWords = ''
      this.filterFrom.schoolCode = this.userInfo.schoolCode
      this.filterFrom.teacherId = this.userInfo.userId
      this.filterFrom.schoolYear = this.schoolYear
      await this.getStudentListByCodes()
    },
    refresh() {
      this.getStudentListByCodes()
    },
    async gradeChange(val) {
      this.filterFrom.classCode = ''
      this.classOptions = await getData('/school/getClassInfoList', {
        schoolCode: this.userInfo.schoolCode,
        grade: val,
        pageSize: -1,
        pageNum: 1
      })
      this.getStudentListByCodes()
    },
    async onChangeClass() {
      this.getStudentListByCodes()
    },

    showPop(type) {
      this.radiation = {
        radiationType: '',
        num: '',
        id: new Date().getTime()
      }
      this.isShowPop = true
    },
    cancel() {
      this.isShowPop = false
    },
    delRadIation(id) {
      this.form1.radiation = this.form1.radiation.filter((i) => i.id != id)
    },
    addOk() {
      if (this.radiation.radiationType && this.radiation.num) {
        this.form1.radiation.push(this.radiation)
        this.isShowPop = false
      } else {
        this.$message.error('请输入完整信息！')
      }
    },
    showPop2(type) {
      this.articles = {
        articlesType: '',
        num: '',
        id: new Date().getTime()
      }
      this.isShowPop2 = true
    },
    cancel2() {
      this.isShowPop2 = false
    },
    delArticles(id) {
      this.form1.articles = this.form1.articles.filter((i) => i.id != id)
    },
    addOk2() {
      if (this.articles.articlesType && this.articles.num) {
        this.form1.articles.push(this.articles)
        this.isShowPop2 = false
      } else {
        this.$message.error('请输入完整信息！')
      }
    },
    async addOk3() {
      this.btnLoading = true
      let obj = {
        teacherId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        schoolYear: this.schoolYear,
        studentList: this.checkList
      }
      await postJson('/planning/saveMentorStudentInfo', obj)
      this.btnLoading = false
      this.getMentor()
      this.studentCheckedList = []
      this.$message.success('保存成功')
      this.isShowDialog = false
    },
    handleClose() {
      this.isShowDialog = false
      this.studentCheckedList = []
    },
    handelPower() {
      if (!power(this.userInfo.menuInfoList, 'qyds')) {
        this.typeList = this.typeList.filter((f) => {
          return f.code != 'qyds'
        })
      }
    }
  },
  watch: {
    schoolYear: {
      handler(newName, oldName) {
        this.schoolYear = newName
        this.getPlan(newName)
        this.getSum(newName)
        this.getMentor(newName)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-year {
  margin-top: 10px;
  background-color: #fff;
  text-align: center;
  padding-top: 35px;
  padding-bottom: 15px;
  span {
    font-size: 15px;
    margin-right: 10px;
  }
}
.plan {
  .tab-list {
    background-color: #fff;
    padding: 20px 0px;
    border-bottom: 2px solid #eee;
    display: flex;
    justify-content: center;
    .mid {
      // width: 700px;
      margin: 0 auto;
    }
    span {
      font-size: 17px;
      cursor: pointer;
      padding: 6px 8px;
      border-radius: 8px;
      margin: 0px 120px;
    }
    span:hover {
      color: @color;
      //background-color: @hover-bg;
    }
    .active {
      color: @color;
      //background-color: @hover-bg;
    }
  }
  .content {
    background-color: #fff;

    padding: 35px 10px;
    .setp-form {
      padding-bottom: 30px;
      width: 800px;
      margin: 0 auto;
    }
    .myfx {
      font-size: 14.5px;
      margin-left: 70px;
      margin-bottom: 10px;
    }
    .sub-div {
      margin-top: 30px;
      text-align: center;
    }
    .fs-ul {
      margin-top: -5px;
      padding: 0px;
    }
    .delrad {
      padding-left: 8px;
      color: @hong;
      font-size: 15px;
    }
  }
  //}

  /deep/.el-dialog--center {
    border-radius: 15px;
  }
  /deep/.el-dialog--center .el-dialog__body {
    padding: 0px 30px;
  }
  .transfer-box {
    padding: 40px;
    border: 1px solid rgb(231, 227, 227);
    border-radius: 5px;
    text-align: center;
  }
  .student-list {
    width: 100%;
    flex: 50%;

    .infinite-list {
      padding: 0;
      margin: 0;
      max-height: 500px;

      .el-checkbox-group {
        display: grid;
        grid-template-columns: 20% 20% 20% 20% 20%;
      }
    }
    .checked-list {
      display: grid;
      grid-template-columns: 20% 20% 20% 20% 20%;
      li {
        display: inline-block;
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 0;
        color: #81b337;
        background-color: #f1fddc;
        display: inline-block;
        line-height: 1;
        font-weight: 500;
        white-space: nowrap;
        vertical-align: middle;
        border: 1px solid #dcdfe6;
        border-left: 0;
        margin: 5px;
      }
    }
  }
}
</style>
<style lang="less">
.student-list {
  .el-checkbox-group {
    .el-checkbox-button__inner {
      display: inline-block;
      width: 100%;
      margin: 5px;
    }
  }
}
</style>
